function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.3 269.2H14.2v-68.7l66.6-20.1v-77.8L14.2 82.9V14.2h255.1v68.7L203 102.7v77.8l66.3 20.1v68.6zM42.7 240.7h198.1v-19l-66.3-20.1V81.4l66.3-19.8v-19H42.7v19l66.6 19.8v120.2l-66.6 20.1v19z"
})));